import { ViewPath } from '@ContractBuilder/contract-builder-header/constants';

// Not ViewPath.Endorsements — that segment belongs to the endorsement's own path.
const VIEW_SEGMENTS: string[] = [ViewPath.Contract, ViewPath.Form, ViewPath.EndorsementView, ViewPath.ComparisonView];

export const getDocumentUrl = ({ origin, pathname }: Location): string => {
  const segments = pathname.split('/').filter(Boolean);

  if (VIEW_SEGMENTS.includes(segments.at(-1) ?? '')) {
    segments.pop();
  }

  return `${origin}/${segments.join('/')}`;
};
